import React from "react";
import { Route, Switch } from "react-router-dom";
import GatewayNameList from "./container/gateway-name-list";

export default function GatewayNameRoutes({ match }) {
  return (
    <Switch>
      <Route exact path={`${match.url}/`} component={GatewayNameList} />
    </Switch>
  );
}
